import React, {useEffect, useState} from "react";
import PageContainer from "../../layouts/PageContainer";
import {helpers} from '../../helper/helper';
import {useCallback} from "react";
import UsersList from "./TasksConfigList";
import Loader from "../../layouts/Loader";
import {useSnackbar} from "notistack";
import Swal from "sweetalert2";

const TasksConfigImages = () => {
    const {enqueueSnackbar} = useSnackbar();
    const [skip, setSkip] = useState(1);
    const [loading, setLoading] = React.useState(false);
    const [limit, setLimit] = useState(10);
    const [userList, setUserList] = useState();
    const [open, setOpen] = React.useState(false);
    const [openBlock, setOpenBlock] = React.useState(false);
    const [filterText, setFilterText] = useState({
        query: "",
        queryType: { gender: "", subscribe: "" },
    });
    const handleClose = () => {
        setOpen(false);
    };
    const handleCloseBlock = () => {
        setOpenBlock(false);
    };

    console.log('userList', userList)
    const TaskConfigData = useCallback(async (skip, limit) => {
        setLoading(true);
        const url = `claim-type-images?page=${skip}&queryLimit=${limit}`;
        const result = await helpers.apiCall('GET', url);
        setUserList(result.data);
        setLoading(false);
    }, [setUserList]);

    useEffect(() => {
        TaskConfigData(skip, limit);
        setOpen(false);
        setOpenBlock(false)
    }, [TaskConfigData, skip, limit, filterText]);

    // useEffect(() => {
    //     TaskConfigData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
    // }, [skip, limit, filterText])
    
    // const fetchDataOfFilter = () => {
    //     console.log('filterText inside the fetchData', filterText)
    //     TaskConfigData(skip, limit, filterText?.query, filterText?.queryType?.gender, filterText?.queryType?.subscribe);
    // }

    const deleteGifts = async (type, isDeleted) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.value) {
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
                const url = `claim-type-images`;
                const result = await helpers.apiCall("PUT", url, 
                  {type, isDeleted}
                );
                if (result.status === 200) {

                    TaskConfigData(skip, limit);
                    enqueueSnackbar("Config Deleted successfully", {
                        variant: 'success',
                        autoHideDuration: 3000,
                    });
                    handleClose()
                } else {
                    enqueueSnackbar(result.data ? result.data.message : result.message, {
                        variant: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        });

    };
    const BlockUser = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't to Block /Unblock ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f50057",
            cancelButtonColor: "#263273",
            confirmButtonText: "Yes",
        }).then(async (result) => {
            if (result.value) {
                Swal.fire("", "", "success");
                const url = `users/block/${id}`;
                const result = await helpers.apiCall("PUT", url);
                if (result.status === 200) {
                    handleCloseBlock();
                    TaskConfigData(skip, limit);
                    enqueueSnackbar("User BLocked successfully", {
                        variant: 'success',
                        autoHideDuration: 3000,
                    });
                } else {
                    enqueueSnackbar(result.data ? result.data.message : result.message, {
                        variant: 'error',
                        autoHideDuration: 3000,
                    });
                }
            }
        });

    };
    return (
        <PageContainer pageheading="Task Config Image LIST">
            {!userList || loading ? <div style={{ display: "flex", width: "100%", height: "60vh", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-border" style={{ color: "#F85476" }} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div> :
                <UsersList userList={userList} deleteGifts={deleteGifts} BlockUser={BlockUser} setOpen={setOpen}
                           setOpenBlock={setOpenBlock}
                           open={open}
                           handleClose={handleClose}
                           openBlock={openBlock}
                          //  filterText={filterText}
                          //  setFilterText={setFilterText}
                           skip={skip}
                           setSkip={setSkip}
                           limit={limit}
                           setLimit={setLimit}
                        //    fetchDataOfFilter={fetchDataOfFilter}
                           handleCloseBlock={handleCloseBlock}/>
            }
        </PageContainer>
    )
};
export default TasksConfigImages;